import * as React from "react";

function SvgIcons8NetworkDrive(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M16 4c-1.918 0-3.578.871-4.844 2.125C10.937 6.078 10.734 6 10.5 6A3.514 3.514 0 007 9.5c0 .152.043.266.063.406C5.878 10.72 5 11.965 5 13.5 5 15.973 7.027 18 9.5 18h13c2.473 0 4.5-2.027 4.5-4.5 0-2.441-1.98-4.414-4.406-4.469C21.727 6.148 19.156 4 16 4zm0 2a4.996 4.996 0 014.938 4.219l.156 1 1-.188c.172-.027.297-.031.406-.031 1.39 0 2.5 1.11 2.5 2.5S23.89 16 22.5 16h-13C8.11 16 7 14.89 7 13.5c0-1.043.637-1.934 1.531-2.313l.844-.343-.281-.875A1.508 1.508 0 019 9.5c0-.84.66-1.5 1.5-1.5.176 0 .352.023.531.094l.656.25.47-.531A4.972 4.972 0 0116 6zM3 21v8h26v-8zm2 2h22v4H5zm3 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 0v2h14v-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8NetworkDrive);
